// cache class

import {LRUCache} from 'lru-cache';

interface ServerInMemoryCacheOptions {
  ttl?: number;
}

export class ServerInMemoryCache<T extends {}> {
  private cache;
  private defaultTTL: number;

  constructor(options: ServerInMemoryCacheOptions) {
    const {ttl} = options;
    this.defaultTTL = ttl ?? 1 * 60 * 1000; // default to 1 minute

    this.cache = new LRUCache<string, T>({
      ttl,
      ttlAutopurge: false,
      max: 500, // maximum number of items in the cache. At the point of this write-up we have an estimated number of 40 locale's translations cached. 500 should be more than enough.
      maxEntrySize: 2, // maximum size of an item in the cache => this value doesn't matter since in the `sizeCalculation` we return 1
      sizeCalculation: () => 1, // this is a required option, but we don't use it. Its supposed to return size of the cache, since we dont currently care about the size of the items we just return 1
    });
  }

  public has(key: string): boolean {
    if (process.browser) {
      throw new Error(
        'This method is only expected to be called on the server',
      );
    }
    return this.cache.has(key);
  }

  public get(key: string): T | undefined {
    if (process.browser) {
      throw new Error(
        'This method is only expected to be called on the server',
      );
    }
    return this.cache.get(key);
  }

  public set(key: string, value: T, options?: {ttl?: number}): void {
    if (process.browser) {
      throw new Error(
        'This method is only expected to be called on the server',
      );
    }
    this.cache.set(key, value, {
      ttl: options?.ttl ?? this.defaultTTL,
    });
  }
}
